/**
 * Start states for the application
 */
export const START_STATES = {
  INIT: 'init',
  STARTED: 'started',
};
